module.exports = __webpack_public_path__ + "img/sandtime-outline-orange.63efd381.svg";